import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ProductVariant } from '../data/models';
import { DataService } from '../data/data.service';

@Component({
    selector: 'app-product-variant-selector-modal',
    template: `
    <div class="modal-header">
      <h4 *ngIf="variants.length" class="modal-title text-truncate">{{variants[0].title}}</h4>
      <button type="button" class="btn-close" aria-label="Close" i18n-aria-label (click)="modal.dismiss()"></button>
    </div>
    <div class="modal-body p-0">
      <app-product-details-variant-list class="list-group list-group-flush" [appLoadingOverlay]="loading"
        [variants]="variants"
        (variantSelected)="addToCart($event)"
      ></app-product-details-variant-list>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-lg btn-secondary w-100 w-md-auto mb-2 mb-md-0" (click)="modal.dismiss()" i18n>Abbrechen</button>
    </div>
  `,
    standalone: false
})
export class ProductVariantSelectorComponent {
  @Input() variants: ProductVariant[] = [];

  loading = false;

  constructor(private readonly dataService: DataService,
              public modal: NgbActiveModal) {
  }

  async addToCart(variant: ProductVariant) {
    this.loading = true;
    try {
      await this.dataService.addToCart(variant.id);
      this.modal.dismiss();
    } finally {
      this.loading = false;
    }
  }
}
